import gql from 'graphql-tag'

export const GET_MODEL = gql`
  query VehicleModels($filter: GetVehicleModelsInput) {
    vehicleModels(filter: $filter) {
      isSuccessful
      message
      vehicleModels {
        model
      }
      status
    }
  }
`
